import axios from "axios";
import { APIAdapter } from "../../../../helpers/api_helper";
const api = new APIAdapter();
export const addCommissionCountry = async ({ country, paymentMethods }) => {
  try {
    const response = await api.create(`/business-commissions/global`,
      
       {
      country,
      paymentMethods
    });
    return response.data;
  } catch (error) {
    console.error("Erreur API:", error);
    
    throw error;
  }
};

export const updateCommissionCountry= async ({ id, payInCommission, payOutCommission }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_TRANSACTION}/payment-method/update-commission/${id}`, 
      {
      payInCommission: payInCommission,
      payOutCommission: payOutCommission,
      
    },);
    return response.data;
  } catch (error) {
    console.error(`Erreur API update pour ${id}:`, error);
    throw error;
  }
};

export const getCommissionCountry = async () => {
  try {
    const response = await api.get(`/business-commissions/global-commissions`);
    return response; 
  } catch (error) {
    console.error("Erreur API getCommissionCountry:", error);
    throw error;
  }
};
 export const getAllMerchentCom = async () => {
      try {
        const response = await api.get(`/merchants`)
        return response;
      } catch (error) {
        throw error;
      }
  };
  export const getPaymentMethodBusiness = async (businessId) => {
      try {
        const response = await api.get(`/developer-accounts/payment-methods/${businessId}`);
        return response;
      } catch (error) {
        throw error;
      }
  };
    export const getPaymentMethod = async (id) => {
      try {
           const response = await axios.get(`${process.env.REACT_APP_API_TRANSACTION}/payment-method/${id}`);
        return response.data;
        
      } catch (error) {
        throw error;
      }
  };
  export const getCommissionBusiness = async (businessId) => {
  try {
    const response = await api.get(`/business-commissions/${businessId}`);
    return response; 
  } catch (error) {
    console.error("Erreur API getCommissionBusiness:", error);
    throw error;
  }
};
export const updateCommissionBusiness = async ({cardCommissionPercentage, businessId, countryCode, paymentMethod, payinCommissionPercentage, payoutCommissionPercentage }) => {
  try {
    const response = await api.put(`/business-commissions/${businessId}`, {
      countryCode,
      paymentMethod,
      payinCommissionPercentage,
      payoutCommissionPercentage,
      cardCommissionPercentage
    });
    return response;
  } catch (error) {
    console.error("Erreur API update:", error.response || error.message);
    throw error;
  }
};
export const addCommissionBusiness = async ({ businessId, countryCode, paymentMethod, payinCommissionPercentage, payoutCommissionPercentage,cardCommissionPercentage }) => {
  try {
     const response = await api.create(`/business-commissions/${businessId}`, {
      countryCode,
      paymentMethod,
      payinCommissionPercentage,
      payoutCommissionPercentage,
      cardCommissionPercentage
    });
    return response;
  } catch (error) {
    console.error("Erreur API:", error);
    
    throw error;
  }
};





